// import React from "react";
// import { Container } from "react-bootstrap";
// import { FaFacebookF, FaInstagram, FaPinterestP } from "react-icons/fa";

// const Footer = () => {
//   return (
//     <footer
//       style={{
//         background: "#F3F4F6",
//         padding: "50px 0 30px",
//         cussor:"pointer",
//       }}
//     >
//       <Container>
//         {/* Top Row */}
//         <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
//           <h5 className="fw-bold m-0">Sangam Mairrage Hall</h5>

//           <div className="d-flex gap-4 small" style={{cursor:"pointer"}}>
//             <span>About Us</span>
//             <span>Services</span>
//             <span>Gallery</span>
//             <span>Pricing Packages</span>
//           </div>

//           <div className="d-flex gap-3"style={{cursor:"pointer"}}>
//             <FaFacebookF />
//             <FaInstagram />
//             <FaPinterestP />
//           </div>
//         </div>

        
//         <hr style={{ border: "1px solid #000", opacity: 0.6 }} />

//         {/* Bottom Row */}
//         <div className="d-flex flex-wrap justify-content-center gap-4 mt-4 small">
//           <span>© 2026 Sangam Mairrage Hall. All rights reserved.</span>
//           <span>Terms and Conditions</span>
//           <span>Privacy Policy</span>
//         </div>
//       </Container>
//     </footer>
//   );
// };

// export default Footer;




// import React from "react";
// import { Container } from "react-bootstrap";
// import { FaFacebookF, FaInstagram, FaPinterestP } from "react-icons/fa";
// import { useNavigate, useLocation } from "react-router-dom";

// const Footer = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const handleNavigate = (path) => {
//     navigate(path);
//     window.scrollTo({
//       top: 0,
//       behavior: "smooth",
//     });
//   };

//   return (
//     <footer
//       style={{
//         background: "#F3F4F6",
//         padding: "50px 0 30px",
//         cursor: "pointer",
//       }}
//     >
//       <Container>
//         {/* Top Row */}
//         <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
//           <h5 className="fw-bold m-0">Sangam Mairrage Hall</h5>

//           <div className="d-flex gap-4 small" style={{ cursor: "pointer" }}>
//             <span
//               onClick={() => handleNavigate("/")}
//               style={{
//                 color: location.pathname === "/" ? "#ff3b1f" : "#000",
//               }}
//             >
//               Home
//             </span>

//             <span
//               onClick={() => handleNavigate("/about")}
//               style={{
//                 color:
//                   location.pathname === "/about" ? "#ff3b1f" : "#000",
//               }}
//             >
//               About Us
//             </span>

//             <span
//               onClick={() => handleNavigate("/services")}
//               style={{
//                 color:
//                   location.pathname === "/services"
//                     ? "#ff3b1f"
//                     : "#000",
//               }}
//             >
//               Services
//             </span>

//             <span
//               onClick={() => handleNavigate("/contact")}
//               style={{
//                 color:
//                   location.pathname === "/contact"
//                     ? "#ff3b1f"
//                     : "#000",
//               }}
//             >
//               Contact
//             </span>
//           </div>

//           <div className="d-flex gap-3" style={{ cursor: "pointer" }}>
//             <FaFacebookF />
//             <FaInstagram />
//             <FaPinterestP />
//           </div>
//         </div>

//         <hr style={{ border: "1px solid #000", opacity: 0.6 }} />

//         {/* Bottom Row */}
//         <div className="d-flex flex-wrap justify-content-center gap-4 mt-4 small">
//           <span>
//   © 2026 Sangam Mairrage Hall. All rights reserved.{" "}
//   <span
//     style={{ cursor: "pointer" }}
//     onClick={() =>
//       window.open("https://dectwinservices.com", "_blank")
//     }
//   >
//     Dectwin Services Pvt Ltd
//   </span>

// </span>
//           <span>Terms and Conditions</span>
//           <span>Privacy Policy</span>
//         </div>
//       </Container>
//     </footer>
//   );
// };

// export default Footer;



import React from "react";
import { Container } from "react-bootstrap";
import { FaFacebookF, FaInstagram, FaPinterestP } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import Logo from "../../Images/Logo1.png";

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigate = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <footer
      style={{
        background: "#F3F4F6",
        padding: "50px 0 30px",
        cursor: "pointer",
      }}
    >
      <Container>
        
        <div className="d-flex flex-wrap justify-content-between align-items-center mb-4">
          
          
          <img
            src={Logo}
            alt="Sangam Marriage Hall"
            style={{
              height: "120px",
              width: "120px",
              objectFit: "contain",
              borderRadius: "40px",
            }}
          />

          <div className="d-flex gap-4 small" style={{ cursor: "pointer" }}>
            <span
              onClick={() => handleNavigate("/")}
              style={{
                color: location.pathname === "/" ? "#ff3b1f" : "#000",
              }}
            >
              Home
            </span>

            <span
              onClick={() => handleNavigate("/about")}
              style={{
                color:
                  location.pathname === "/about" ? "#ff3b1f" : "#000",
              }}
            >
              About Us
            </span>

            <span
              onClick={() => handleNavigate("/services")}
              style={{
                color:
                  location.pathname === "/services"
                    ? "#ff3b1f"
                    : "#000",
              }}
            >
              Services
            </span>

            <span
              onClick={() => handleNavigate("/contact")}
              style={{
                color:
                  location.pathname === "/contact"
                    ? "#ff3b1f"
                    : "#000",
              }}
            >
              Contact
            </span>
          </div>

          {/* <div className="d-flex gap-3" style={{ cursor: "pointer" }}>
            <FaFacebookF />
            <FaInstagram />
            
          </div> */}
   <div
  className="d-flex align-items-center justify-content-center gap-3"
  style={{ cursor: "pointer" }}
>
  <a
    href="https://www.facebook.com/share/1B4tb9tzjV/?mibextid=wwXIfr"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "inherit", display: "flex", alignItems: "center" }}
  >
    <FaFacebookF />
  </a>

  <a
    href="https://www.instagram.com/sangam_guesthouse?igsh=eHNtZXNqdXVqZGs0&utm_source=qr"
    target="_blank"
    rel="noopener noreferrer"
    style={{ color: "inherit", display: "flex", alignItems: "center" }}
  >
    <FaInstagram />
  </a>
</div>
        </div>

        <hr style={{ border: "1px solid #000", opacity: 0.6 }} />

    
        <div className="d-flex flex-wrap justify-content-center gap-4 mt-4 small">
          <span>
            © 2026  Sangam Guest House and Marriage Lawn. All rights reserved.{" "}
            <span
              style={{ cursor: "pointer" }}
              onClick={() =>
                window.open("https://dectwinservices.com", "_blank")
              }
            >
              Dectwin Services Pvt Ltd
            </span>
          </span>

          {/* <span>Terms and Conditions</span>
          <span>Privacy Policy</span> */}
        </div>
      </Container>
    </footer>
  );
};

export default Footer;